import React from "react";
import { HubCheckoutOptionalProductItem } from "hub/src/pages/checkout/optional-products/HubCheckoutOptionalProductItem";
import { HubCheckoutOptionalGridProduct } from "hub/src/pages/checkout/optional-products/HubCheckoutOptionalProductItem";

interface OptionalProductGridProps {
  title?: string;
  products: HubCheckoutOptionalGridProduct[];
}

export const HubCheckoutOptionalProductGrid: React.FC<
  OptionalProductGridProps
> = ({ title, products }) => {
  return (
    <div>
      {title && title !== "" && (
        <div>
          <h3 className="mb-2">{title}</h3>
          <hr className="text-neutral-mid-200" />
        </div>
      )}

      <div className="flex flex-col gap-4 pb-2">
        {products.length && (
          <div className="flex justify-start gap-x-2 gap-y-1 flex-row flex-wrap">
            {products.map((product, index) => (
              <HubCheckoutOptionalProductItem
                key={`${product.productId}-${index}}`}
                product={product}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
